import React, { useContext, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import PdfConfig from "components/PdfTest/pdfConfig"
import AuthContext from "context/auth/authContext"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { CUSTOMIZE_PDF } from "constants/entitlements"

const NewPlantillaPdf = () => {
  const { getOrganizationNew, organizationFields, user } =
    useContext(AuthContext)

  useEffect(() => {
    if (user) {
      getOrganizationNew(user["custom:organizationId"])
    }
  }, [user])

  return (
    <EntitlementPageGuard permission={CUSTOMIZE_PDF}>
      <div
        className="page-content"
        style={{ paddingBottom: "0px", paddingTop: "60px" }}
      >
        <Helmet>
          <title>Planhopper - Plantilla</title>
        </Helmet>
        <Container fluid style={{ overflowY: "hidden" }}>
          {organizationFields && <PdfConfig />}
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default NewPlantillaPdf
